import React, { FC } from "react";

const Footer: FC = () => {
  return (
    <footer className="footer">
      <p>
        Created for{" "}
        <u>
          <a href="https://www.radency.com/" target="_blank" rel="noreferrer">
            Radency
          </a>
        </u>{" "}
        Internship
      </p>
      <p>by Anastasiia Bahinska</p>
    </footer>
  );
};

export default Footer;
